export default __webpack_public_path__ + "static/media/Akhlak Hossain Jim  Resume.b853566a.pdf";